import React from 'react';
import { Text, View } from 'react-native';
import CutCard from '@/components/General/CutCard';
import Unicon from '@/components/General/Unicon';
import { SERVICE_FLOW_ITEM_TYPE_LIST } from '@/config/serviceFlows';
import { serviceFlowStyles } from './serviceFlowStyles';

/**
 * The type choices shown before adding a flow item (spec §3.4). Each option:
 * icon, name, one-line description. Types flagged `hiddenInPicker` (Worship,
 * until songs/positions land) stay in the data contract but aren't offered.
 */
const ServiceFlowItemTypePicker = ({ onSelect, disabled = false }) => (
    <View style={serviceFlowStyles.typeOptions}>
        {SERVICE_FLOW_ITEM_TYPE_LIST.filter(t => !t.hiddenInPicker).map(t => (
            <CutCard
                key={t.type}
                testID={`service-flow-type-${t.type.toLowerCase()}`}
                disabled={disabled}
                onPress={() => onSelect(t.type)}
                accessibilityLabel={t.label}
                contentStyle={serviceFlowStyles.typeOption}
            >
                <View style={serviceFlowStyles.typeOptionIcon}>
                    <Unicon name={t.icon} size={17} colorVariant="events" />
                </View>
                <View style={{ flex: 1 }}>
                    <Text style={serviceFlowStyles.typeOptionTitle}>{t.label}</Text>
                    <Text style={serviceFlowStyles.typeOptionDescription}>{t.description}</Text>
                </View>
                <Unicon name="chevron-forward" size={14} colorVariant="textSecondary" />
            </CutCard>
        ))}
    </View>
);

export default ServiceFlowItemTypePicker;
